import React from "react";
import { Link } from "react-router-dom";
import Helper from "../Helper/helper";
import api from "../../Environment";
import { withToastManager } from "react-toast-notifications";
import ToastDemo from "../Helper/toaster";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { apiConstants } from "../Constant/constants";
import configuration from "react-global-configuration";
import {
  StandalonePageHeader,
  StandalonePageLogo,
} from "../Layouts/SubLayout/StandalonePageLogo";
import { getGooglePublicClientId, getFacebookAppId, loadAuthConfig } from "../../auth/authConfigService";

import { translate } from "react-multi-lang";
import GoogleSignInButton from "./GoogleSignInButton";
import {
  mapGoogleJwtToRegisterPayload,
  googleAuthNetworkErrorMessage,
} from "./googleAuth";
import { fetchRequiredDocuments, legalDocumentPath } from "../Legal/legalApi";
import DestinationExperienceGate from "../Experience/DestinationExperienceGate";
import "./RegisterLegalConsent.css";
var const_time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;

class RegisterComponent extends Helper {
  state = {
    data: {
      email: "",
      password: "",
      name: "",
      timezone: const_time_zone,
      referral_code: "",
    },
    loadingContent: null,
    buttonDisable: false,
    check_referral_response: "",
    // Legal consent — fetched dynamically; NEVER hardcoded here.
    requiredDocuments: [],
    acceptedVersions: {},
    authProvidersReady: false,
    facebookAppId: "",
    googleClientId: "",
  };

  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search);
    const referral = query.get("referral");
    if (referral) {
      this.setState((prev) => ({
        data: { ...prev.data, referral_code: referral },
      }));
    }

    loadAuthConfig({ force: false })
      .catch(function () {
        return null;
      })
      .then(() => {
        this.setState({
          authProvidersReady: true,
          facebookAppId: getFacebookAppId() || "",
          googleClientId: getGooglePublicClientId() || "",
        });
      });

    fetchRequiredDocuments("new")
      .then((documents) => {
        const accepted = {};
        documents.forEach((doc) => {
          // Unchecked by default — never preselect.
          accepted[doc.version_id] = false;
        });
        this.setState({ requiredDocuments: documents, acceptedVersions: accepted });
      })
      .catch(() => {
        this.setState({ requiredDocuments: [], acceptedVersions: {} });
      });
  }

  toggleConsent = (versionId) => (event) => {
    const checked = event.target.checked;
    this.setState((prev) => ({
      acceptedVersions: { ...prev.acceptedVersions, [versionId]: checked },
    }));
  };

  allConsentsAccepted = () => {
    const { requiredDocuments, acceptedVersions } = this.state;
    return requiredDocuments.every((doc) => !!acceptedVersions[doc.version_id]);
  };

  acceptedVersionIds = () => {
    const { requiredDocuments, acceptedVersions } = this.state;
    return requiredDocuments
      .filter((doc) => !!acceptedVersions[doc.version_id])
      .map((doc) => doc.version_id);
  };

  ensureConsent = () => {
    if (this.allConsentsAccepted()) {
      return true;
    }
    ToastDemo(
      this.props.toastManager,
      "Please accept all required documents to continue.",
      "error"
    );
    return false;
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (!this.ensureConsent()) {
      return;
    }
    const { state } = this.props.location;
    this.setState({
      loadingContent: this.props.t("button_loading"),
      buttonDisable: true,
    });
    api
      .postMethod("v4/register", {
        ...this.state.data,
        accepted_legal_versions: this.acceptedVersionIds(),
      })
      .then((response) => {
        if (response.data.success) {
          localStorage.setItem("userId", response.data.data.user_id);
          localStorage.setItem("accessToken", response.data.data.token);
          localStorage.setItem("userType", response.data.data.user_type);
          localStorage.setItem("push_status", response.data.data.push_status);
          localStorage.setItem("username", response.data.data.name);
          localStorage.setItem(
            "active_profile_id",
            response.data.data.sub_profile_id
          );
          ToastDemo(this.props.toastManager, response.data.message, "success");
          this.props.history.push("/view-profiles");
          this.setState({
            loadingContent: null,
            buttonDisable: false,
          });

          // window.location = state ? state.from.pathname : "/";
        } else {
          ToastDemo(
            this.props.toastManager,
            response.data.error_messages,
            "error"
          );
          this.setState({
            loadingContent: null,
            buttonDisable: false,
          });

          if (response.data.error_code == 3001) {
            setTimeout(function() {
              window.location = "/login";
            }, 3000);
          }
        }
      })
      .catch((error) => {
        this.setState({ loadingContent: null, buttonDisable: false });
        ToastDemo(this.props.toastManager, error, "error");
      });
  };

  responseFacebook = (response) => {
    if (response) {
      if (response.status === "unknown") {
        ToastDemo(this.props.toastManager, "Cancelled", "error");
        return false;
      }
      if (!this.ensureConsent()) {
        return false;
      }
      if (!response.accessToken) {
        ToastDemo(
          this.props.toastManager,
          "Facebook access token missing. Please try again.",
          "error"
        );
        return false;
      }
      const emailAddress =
        response.email === undefined || response.email === null
          ? null
          : response.email;

      if (!emailAddress) {
        ToastDemo(
          this.props.toastManager,
          "Facebook email permission is required. Please allow email access and try again.",
          "error"
        );
        return false;
      }

      const facebookLoginInput = {
        social_unique_id: response.id,
        access_token: response.accessToken,
        login_by: "facebook",
        email: emailAddress,
        name: response.name,
        device_type: "web",
        device_token: apiConstants.DEVICE_TOKEN,
        timezone: const_time_zone,
        accepted_legal_versions: this.acceptedVersionIds(),
      };
      api
        .postMethod("v4/register", facebookLoginInput)
        .then((response) => {
          if (response.data.success === true) {
            localStorage.setItem("userId", response.data.data.user_id);
            localStorage.setItem("accessToken", response.data.data.token);
            localStorage.setItem("push_status", response.data.data.push_status);
            localStorage.setItem("userType", response.data.data.user_type);

            localStorage.setItem("username", response.data.data.name);
            localStorage.setItem(
              "active_profile_id",
              response.data.data.sub_profile_id
            );
            ToastDemo(
              this.props.toastManager,
              response.data.message,
              "success"
            );
            this.props.history.push("/view-profiles");
            this.setState({
              loadingContent: null,
              buttonDisable: false,
            });
          } else {
            ToastDemo(
              this.props.toastManager,
              response.data.error_messages ||
                response.data.message ||
                "Facebook sign-in failed.",
              "error"
            );
            this.setState({
              loadingContent: null,
              buttonDisable: false,
            });
          }
        })
        .catch((error) => {
          ToastDemo(
            this.props.toastManager,
            (error &&
              error.response &&
              error.response.data &&
              (error.response.data.error_messages ||
                error.response.data.message)) ||
              (error && error.message) ||
              "Facebook sign-in failed.",
            "error"
          );
          this.setState({ loadingContent: null, buttonDisable: false });
        });
    }
  };

  /**
   * Google Identity Services credential JWT + raw token for server verification (LQI-C02).
   */
  responseGoogle = (decoded, idToken) => {
    if (!decoded || !decoded.sub) {
      ToastDemo(
        this.props.toastManager,
        "Invalid Google credential. Please try again.",
        "error"
      );
      return;
    }

    if (!idToken || !String(idToken).trim()) {
      ToastDemo(
        this.props.toastManager,
        "Google ID token is required for Google sign-in.",
        "error"
      );
      this.setState({ buttonDisable: false });
      return;
    }

    if (!this.ensureConsent()) {
      return;
    }

    this.setState({ buttonDisable: true });

    let googleLoginInput;
    try {
      googleLoginInput = mapGoogleJwtToRegisterPayload(
        decoded,
        apiConstants.DEVICE_TOKEN,
        const_time_zone,
        idToken
      );
      googleLoginInput.accepted_legal_versions = this.acceptedVersionIds();
    } catch (mapError) {
      ToastDemo(
        this.props.toastManager,
        (mapError && mapError.message) ||
          "Google ID token is required for Google sign-in.",
        "error"
      );
      this.setState({ buttonDisable: false });
      return;
    }

    api
      .postMethod("v4/register", googleLoginInput)
      .then((response) => {
        if (response.data.success === true) {
          localStorage.setItem("userId", response.data.data.user_id);
          localStorage.setItem("accessToken", response.data.data.token);
          localStorage.setItem("userType", response.data.data.user_type);
          localStorage.setItem("push_status", response.data.data.push_status);
          localStorage.setItem("username", response.data.data.name);
          localStorage.setItem(
            "active_profile_id",
            response.data.data.sub_profile_id
          );
          ToastDemo(
            this.props.toastManager,
            response.data.message,
            "success"
          );
          this.props.history.push("/view-profiles");
          this.setState({
            loadingContent: null,
            buttonDisable: false,
          });
        } else {
          ToastDemo(
            this.props.toastManager,
            response.data.error_messages ||
              response.data.message ||
              "Google sign-in failed. Please try again.",
            "error"
          );
          this.setState({
            loadingContent: null,
            buttonDisable: false,
          });
        }
      })
      .catch((error) => {
        ToastDemo(
          this.props.toastManager,
          googleAuthNetworkErrorMessage(error),
          "error"
        );
        this.setState({
          loadingContent: null,
          buttonDisable: false,
        });
      });
  };

  responseGoogleError = (message) => {
    ToastDemo(
      this.props.toastManager,
      message || "Google sign-in was cancelled.",
      "error"
    );
  };

  checkReferralCode = (event) => {
    event.preventDefault();

    if (this.state.data.referral_code) {
      let inputData = {
        referral_code: this.state.data.referral_code,
      };
      api
        .postMethod("referral_code_validate", inputData)
        .then((response) => {
          if (response.data.success === true) {
            this.setState({
              loadingContent: null,
              buttonDisable: false,
              check_referral_response: response.data.message,
            });
          } else {
            ToastDemo(
              this.props.toastManager,
              response.data.error_messages,
              "error"
            );

            // this.setState({
            //     check_referral_response: response.data.error
            // });
          }
        })
        .catch((error) => {
          ToastDemo(this.props.toastManager, error, "error");
        });
    }
  };

  render() {
    const { t } = this.props;
    var bgImg = {
      backgroundImage: `url(${configuration.get(
        "configData.common_bg_image"
      )})`,
    };
    const { data } = this.state;
    return (
      <DestinationExperienceGate destinationType="register">
      <div>
        <div className="common-bg-img" style={bgImg}>
          <StandalonePageHeader variant="auth">
            <StandalonePageLogo linkTo="/" />
          </StandalonePageHeader>

          <div className="row">
            <div className="col-sm-9 col-md-7 col-lg-5 col-xl-4 auto-margin">
              <div className="register-box">
                <h3 className="register-box-head">{t("signup")}</h3>
                <form
                  className="auth-form login-new-form"
                  onSubmit={this.handleSubmit}
                >
                  <div className="form-group">
                    <label className="sr-only" htmlFor="name">
                      {t("full_name")}
                    </label>
                    <input
                      onChange={this.handleChange}
                      className="form-control"
                      id="name"
                      name="name"
                      placeholder={t('name')}
                      aria-label={t("full_name")}
                      value={data.name}
                    />
                  </div>
                  <div className="form-group">
                    <label className="sr-only" htmlFor="email">
                      {t("email_address")}
                    </label>
                    <input
                      type="email"
                      onChange={this.handleChange}
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder={t('email_address')}
                      aria-label={t("email_address")}
                      value={data.email}
                    />
                  </div>
                  <div className="form-group">
                    <label className="sr-only" htmlFor="pwd">
                      {t("password")}
                    </label>
                    <input
                      type="password"
                      onChange={this.handleChange}
                      className="form-control"
                      id="pwd"
                      name="password"
                      placeholder={t("password")}
                      aria-label={t("password")}
                      value={data.password}
                    />
                  </div>

                  <div className="form-group">
                    <label className="sr-only" htmlFor="referral_code">
                      {t("signup_referral_code_label")}
                    </label>
                    <input
                      type="text"
                      onChange={this.handleChange}
                      className="form-control"
                      id="referral_code"
                      name="referral_code"
                      placeholder={t("referral_code_optional")}
                      aria-label={t("referral_code_optional")}
                      value={this.state.data.referral_code}
                    />

                    {this.state.data.referral_code ? (
                      <a
                        className="text-warning"
                        href="#"
                        onClick={this.checkReferralCode}
                      >
                        {t("check_referral_code_valid")}

                        {this.state.check_referral_response ? (
                          <p className="text-success">
                            {this.state.check_referral_response}
                          </p>
                        ) : (
                          ""
                        )}
                      </a>
                    ) : (
                      ""
                    )}
                  </div>

                  {this.state.requiredDocuments.length > 0 ? (
                    <div className="form-group legal-consent-group">
                      {this.state.requiredDocuments.map((doc) => (
                        <label
                          key={doc.version_id}
                          className="legal-consent-item"
                        >
                          <input
                            type="checkbox"
                            name={"legal_consent_" + doc.version_id}
                            checked={!!this.state.acceptedVersions[doc.version_id]}
                            onChange={this.toggleConsent(doc.version_id)}
                          />
                          <span className="legal-consent-prefix">
                            I agree to the{" "}
                          </span>
                          <a
                            href={doc.url || legalDocumentPath(doc.slug)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="legal-consent-link"
                          >
                            {doc.title}
                          </a>
                        </label>
                      ))}
                    </div>
                  ) : null}

                  <button
                    className="btn btn-danger auth-btn"
                    disabled={
                      this.state.buttonDisable || !this.allConsentsAccepted()
                    }
                  >
                    {this.state.loadingContent != null
                      ? this.state.loadingContent
                      : t("signup")}
                  </button>
                </form>

                <div>
                  {this.state.authProvidersReady && this.state.facebookAppId ? (
                    <FacebookLogin
                      key={"fb-" + this.state.facebookAppId}
                      appId={this.state.facebookAppId}
                      fields="name,email,picture"
                      scope="public_profile,email"
                      callback={this.responseFacebook}
                      disableMobileRedirect={true}
                      isMobile={false}
                      version="18.0"
                      render={(renderProps) => (
                        <button
                          type="button"
                          className="social"
                          onClick={renderProps.onClick}
                          disabled={
                            this.state.buttonDisable || renderProps.disabled
                          }
                        >
                          <i className="fab fa-facebook fb social-icons" />{" "}
                          {t("login_with")} {t("facebook")}
                        </button>
                      )}
                    />
                  ) : null}
                </div>
                <div>
                  {(this.state.googleClientId || getGooglePublicClientId()) ? (
                    <GoogleSignInButton
                      label={t("login_with") + " " + t("google")}
                      onDecoded={this.responseGoogle}
                      onError={this.responseGoogleError}
                      disabled={this.state.buttonDisable}
                    />
                  ) : null}
                </div>

                <p className="auth-link">
                  <span className="grey-text">
                    {" "}
                    {t("already_have_account")}{" "}
                  </span>
                  <Link to={"/login"} className="btn-link">
                    {t("sign_in_now")}
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </DestinationExperienceGate>
    );
  }
}

export default withToastManager(translate(RegisterComponent));
